import Icon from '../../../../../../../components/Icon'
import { useLocation } from "react-router-dom";
import Link from '../../../../../../../components/Link'
import { connect } from 'react-redux';
import { CategoryDto } from '../../../../../../../types/category';
import { Group } from '../../../../../../../types';
import { useWindowSize } from '../../../../../../../hooks/useWindowSize';
import arrowForwardUpRight from '../../../../../../../assets/icons/arrow_forward_up_right-semibold.svg'

type CustomCategoryDto = Omit<CategoryDto, 'id'> & { id: number | 'without_category' };

interface ComponentProps {
  group: Group;
  groupStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  category: CustomCategoryDto
  onClick: () => void
}

const Component = ({
  group,
  category,
  onClick
}: ComponentProps) => {
  const { isMobile } = useWindowSize()
  const location = useLocation()

  return (
    <Link
      onClick={onClick}
      options={{
        type: 'filled',
        size: 'lg',
        skin: 'black'
      }}
      style={{ borderRadius: 30, gap: 8 }}
      href={`/group/${group?.id}/p/c/${category?.id || 'without_category'}`}
    >
      Explorar nueva categoria 🎉
    </Link>
  )
}


const state = ({ groupStore }) => {
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates,
  };
};

export default connect(state)(Component);